import axios from 'axios';
import * as apiPath from './apiPath';
import * as header from './apiHeaders';

export const getCountryCode = () => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.getCountryCode}`, options);
  return res;
}

export const getCountryBySearch = async (searchChars) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = await axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.searchCountry}` + '?search=' + searchChars, options);
  return res;
}

export const getCompanyBySearch = (searchChars,type) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.commonGroupSearch}?search=${searchChars}&type=${type}`, options);
  return res;
}

export const getRunningGroupBySearch = (searchChars,type) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.commonGroupSearch}?search=${searchChars}&type=${type}`, options);
  return res;
}

export const getStateBySearch = (searchChars, countryId) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.searchState}` + '?search=' + searchChars + '&id=' + countryId, options);
  return res;
}
export const getCityBySearch = (searchChars, stateId) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.searchCity}` +
    '?search=' +
    searchChars +
    '&id=' +
    stateId, options);
  return res;
}
export const getGroupBySearch = (searchChars, type) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.commonGroupSearch}` +
    '?search=' +
    searchChars +
    '&type=' +
    type, options);
  return res;
}

export const getPinCodeBySearch = (searchChars) => {
  let options = header.getWithOutAuthJSONHeader();
  const res = axios.get(`${process.env.REACT_APP_MASTER_PATH}${apiPath.searchPincode}` +
    '?code=' +
    searchChars, options);
  return res;
}

export const getHealthCheck = async () => {
  let headers = header.getWithOutAuthJSONHeader();
  const res = await axios.get(
    `${process.env.REACT_APP_AUTH_URL}${apiPath.csrfToken}`,
    headers
  );
  return res;
}


